import * as React from 'react';
import Modal from 'react-modal';
import { ModalContainer, modalStyle, ModalCloseButton } from './styled/Modal';

interface Props {
  close?: any;
  isOpen: boolean;
  contentLabel: string;
  children: React.ReactNode;
}

export const MainModal = (props: Props) => (
  <Modal
    isOpen={props.isOpen}
    onRequestClose={props.close}
    style={modalStyle}
    contentLabel={props.contentLabel}
    ariaHideApp={false}
    shouldCloseOnOverlayClick={false}
  >
    { props.close && <ModalCloseButton className="fas fa-window-close fa-2x" onClick={props.close} /> }
    <ModalContainer>{ props.children }</ModalContainer>
  </Modal>
);
